import $ from 'jquery';
import slick from "slick-carousel";

export default function InfoBoxes() {
    $(function () {
        $(".slick-boxes").slick({
            dots: false,
            arrows: false,
            centerMode: true,
            slidesToShow: 2,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    })
};
